import { useRouteLoaderData } from 'react-router'

export interface SharedAppConfig {
  platformUiUrl: string;
  shubExploreUrl: string;
  pactflowAppUrl: string;
  reflectAppUrl: string;
  shubAppUrl: string;
  portalRootUrl?: string;
  portalAppUrl: string;
  catalogAppUrl?: string;
  replicatedHaloAIEnabled?: string;
  kotsHaloAIEnabled?: string;
}

export const useAppConfig = (): SharedAppConfig => {
  const { appConfig } = useRouteLoaderData<{ appConfig?: SharedAppConfig }>('root') || {}
  return appConfig || {
    platformUiUrl: '',
    shubExploreUrl: '',
    pactflowAppUrl: '',
    shubAppUrl: '',
    portalRootUrl: '',
    portalAppUrl: '',
    reflectAppUrl: '',
    catalogAppUrl: '',
  }
}
